import React from 'react';

import { ButtonLink } from 'js/design_system/link/ButtonLink';

type CoScientistCtaProps = {
  href: string;
  size?: 'sm' | 'lg';
  fullWidth?: boolean;
  secondary?: boolean;
  withArrow?: boolean;
  children: React.ReactNode;
};

/** Main "try Co-scientist" CTA */
export const CoScientistCta: React.FC<CoScientistCtaProps> = ({
  href,
  size = 'lg',
  fullWidth = false,
  secondary = false,
  withArrow = false,
  children,
}) => (
  <ButtonLink
    href={href}
    size={size}
    iconRight={withArrow ? 'arrow_forward' : undefined}
    fullWidth={fullWidth}
    secondary={secondary}
  >
    {children}
  </ButtonLink>
);
